<template>
  <div id="slider-ctn" class="flex width-100 overflow-hidden relative z-index-default"
    :style="`minHeight: ${ballDiameter +'px'}`"
    style="height: 100%;"
  >
    <input
      v-bind="$attrs"
      type="range"
      class="absolute absolute-center no-highlights z-index-slider"
      tabindex="-1"
      :class="[fontColor]"
      :min
      :max
      :value="selection"
      @keydown.enter.prevent
      @keydown.left.prevent
      @keydown.right.prevent
      @keyup.enter.prevent
      @keyup.left.prevent="updateChange($event.target as HTMLInputElement, `${min}`)"
      @keyup.right.prevent="updateChange($event.target as HTMLInputElement, `${max}`)"
      @input="updateSlider($event.target as HTMLInputElement)"
      @change="updateChange($event.target as HTMLInputElement)"
      @touchstart="updateSlider($event.target as HTMLInputElement)"
      @touchend="(e: Event) => { updateSlider(e.target as HTMLInputElement); updateChange(e.target as HTMLInputElement); }"
      />
    <div class="flex flex-center width-100 height-100 z-index-default margin-auto"
     :class="`${selection > 50 ? 'margin-thumb-right' : 'margin-thumb-left'} ${idle? 'idle-animation' : ''}`"
    :style="{ transform: `translateX(${tumbTranslate}%)`}"
    >
      <SliderThumb v-if="ballDiameter" class="flex max-height-thumb unselectable" :ballSize="ballDiameter" :color="props.fontColor === FontColor.primary ? Color.black : Color.white" :selection />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { Color, FontColor } from '../../interfaces'
import { SliderThumb } from '../icons';
import { normalizeBetweenRange } from '../../utils';
const emit = defineEmits(['update:selection', 'update:change'])
export interface PropsDot {
  selection?: number
  fontColor?: FontColor
  min?: number
  max?: number
  extremaThumb?: number
  ballDiameter?: number
}
const props = withDefaults(defineProps<PropsDot>(), {
  fontColor: FontColor.secondary,
  selection: 50,
  min: 0,
  max: 100,
  extremaThumb: 27,
  ballDiameter: 0
})
const idle = ref<Boolean>(true)
const value = ref<number>(0)
const updateSlider = (event:HTMLInputElement) => {

  value.value = +event.value
  emit('update:selection', +event.value)
}
const updateChange = (event:HTMLInputElement, el?: string) => {
  if (el) emit('update:change', +el)
  else emit('update:change', +event.value)
}

const tumbTranslate = computed(() => {
  if (tumbTranslate.value && idle.value){ idle.value = false}
  const normalize = normalizeBetweenRange(props.selection, {min: -props.extremaThumb, max: props.extremaThumb}, {min: props.min, max: props.max})
  return `${normalize}`
})

</script>
<style lang="scss" scoped>

$border-radius: 4px;
$track-height: 100%;
$track-color-primary: var(--secondary-font-color, #ffffff);
$track-color-secondary: var(--primary-font-color, #53565A);

#slider-ctn{
  border-radius: 15rem;
}

input[type=range].primary-font-color {
  background: $track-color-secondary;
}
input[type=range].secondary-font-color {
  background: $track-color-primary;
}

input[type=range] {
  opacity: 0;
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
  background-color: transparent; /* Otherwise white in Chrome */
  margin: 0;
  height: $track-height;
}
.padding-thumb {
  margin: 0 1.5rem;
}
input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
input[type=range]:active
input[type=range]:focus {
  outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
  background-color: transparent; /* Otherwise white in Chrome */
  margin: 0;
  height: $track-height;
}

input[type=range]::-ms-track {
  width: 100%;
  cursor: pointer;
  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  height: $track-height;
}


/* TRACK */
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: $track-height;
  cursor: pointer;
  border-radius: $border-radius;
}
.margin-thumb-left {
  margin-left:1pt;
}

.margin-thumb-right{
  margin-right:1pt;
}
// .margin-thumb-left {
//   @media screen and (max-width: 1440px) {
//     margin-left: 0.2rem;
//   }
//   @media screen and (max-width: 1024px) {
//     margin-left: 0.3rem;
//   }
//   @media screen and (orientation: portrait) and (max-width: 1024px) {
//     margin-left: 0.1rem;
//   }
//   @media screen and (orientation: portrait) and (max-width: 600px) {
//     margin-left: 0.2rem;
//   }
//   @media screen and (orientation: portrait) and (max-width: 480px) {
//     margin-left: 0.4rem;
//   }
//   @media screen and (max-width: 600px) {
//     margin-right: 0.2rem;
//   }
//   @media screen and (max-width: 480px) {
//     margin-right: 0.5rem;
//   }
// }
// .margin-thumb-right {
//   @media screen and (max-width: 1440px) {
//     margin-right: 0.2rem;
//   }
//   @media screen and (max-width: 1024px) {
//     margin-right: 0.5rem;
//   }
//   @media screen and (orientation:portrait) and (max-width: 1024px) {
//     margin-right: 0rem;
//   }
//   @media screen and (max-width: 600px) {
//     margin-right: 0.2rem;
//   }
//   @media screen and (max-width: 480px) {
//     margin-right: 0.5rem;
//   }
// }
input[type=range].primary-font-color:focus::-webkit-slider-runnable-track {
      background: $track-color-secondary!important;
      border:none;
      // border: 1px solid #F7C1B7;
}
input[type=range].secondary-font-color:focus::-webkit-slider-runnable-track {
      background: $track-color-primary!important;
      border: none;
      // box-shadow: 1px 1px 1px var( --button-primary-text-shadow-color, '#393939');
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: $track-height;
  cursor: pointer;
  border-radius: $border-radius;
}

input[type=range]::-ms-track {
  width: 100%;
  height: $track-height;
  cursor: pointer;
  border-radius: $border-radius;
}
input[type=range]::-ms-fill-lower {
  border-radius: $border-radius;
}

input[type=range]::-ms-fill-upper {
  border-radius: $border-radius;
}

input[type=range]:focus::-ms-fill-lower {
  background: $track-color-primary;
}

input[type=range]:focus::-ms-fill-upper {
  background:$track-color-primary;
}

/* THUMB */
$thumb-width:48%;
$thumb-height: 100%;
// $thumb-color: var(--secondary-font-color, #ffff);
$thumb-color: transparent;

/* Special styling for WebKit/Blink */
input[type=range]::-webkit-slider-thumb {
  box-shadow: none !important;
  -webkit-appearance: none;
  border: none;
  height: $thumb-height;
  width: $thumb-width;
  background: $thumb-color;
  cursor: pointer;
  margin-top: -14px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
}

/* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {
  box-shadow: none !important;
  border: none;
  height: $thumb-height;
  width: $thumb-width;
  background: $thumb-color;
  cursor: pointer;
}

/* All the same stuff for IE */
input[type=range]::-ms-thumb {
  box-shadow: none !important;
  border: none;
  height: $thumb-height;
  width: $thumb-width;
  background: $thumb-color;
  cursor: pointer;
}
.z-index-slider {
  z-index: 110;
}
.max-height-thumb {
  height: 100%;
}

.idle-animation{
  animation: slidein 1.03s ease-in-out infinite alternate;
}

@keyframes slidein {
  0%, 33% {
    transform: translateX(-4%);
  }
   66%,100% {
    transform: translateX(4%);
  }
}
</style>
